import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import './fonts/GeogrotesqueCyr-Bold.ttf';
import { BrowserRouter, useLocation } from 'react-router-dom';
import AnalyticsScripts from './components/AnalyticsScripts';
import HeatmapTracker from './components/HeatmapTracker';
import Header from './components/Header';
import Footer from './components/Footer';

const STANDALONE_PAGES = ['/floor-scraper-rental', '/proposal/', '/invoice/', '/admin'];

function Layout() {
     const { pathname } = useLocation();
     const isStandalone = STANDALONE_PAGES.some((p) => pathname.startsWith(p));
     return (
          <>
               <AnalyticsScripts />
               <HeatmapTracker />
               {!isStandalone && <Header />}
               <main>
                    <App />
               </main>
               {!isStandalone && <Footer />}
          </>
     );
}

ReactDOM.render(
     <React.StrictMode>
          <BrowserRouter>
               <Layout />
          </BrowserRouter>
     </React.StrictMode>,
     document.getElementById('root')
);
